import { Component, Input, OnChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import JsBarcode from 'jsbarcode';

@Component({
  selector: 'app-barcode',
  standalone: true,
  imports: [CommonModule],
  template: `<svg #barcodeEl class="w-full h-auto"></svg>`
})
export class BarcodeComponent implements AfterViewInit, OnChanges {
  @Input() value = '';
  @Input() width = 2;
  @Input() height = 60;

  @ViewChild('barcodeEl') barcodeEl!: ElementRef<SVGElement>;

  ngAfterViewInit() { 
    this.render(); 
  }
  
  ngOnChanges() { 
    this.render(); 
  }

  private render() {
    if (!this.barcodeEl || !this.value || this.value.trim() === '') return;
    
    try {
      // Limpiar el contenido del SVG
      const svg = this.barcodeEl.nativeElement;
      while (svg.firstChild) {
        svg.removeChild(svg.firstChild);
      }
      
      // Generar el código de barras
      JsBarcode(svg, this.value, {
        format: 'CODE128',
        width: this.width,
        height: this.height,
        displayValue: true,
        fontSize: 14,
        margin: 10,
        lineColor: '#000000',
        background: '#ffffff'
      });
    } catch (e) {
      console.error('Error generando código de barras:', e);
    }
  }
}